import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex p-col-12 p-md-4 p-3 bg-white mb-4 rounded " }
const _hoisted_2 = { class: "grid lg:grid-cols-3 md:grid-cols-3 grid-cols-2 gap-4" }
const _hoisted_3 = { class: "bg-white px-6 py-4 rounded-lg w-full relative" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "pb-6" }, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-users text-6xl" })
], -1)
const _hoisted_5 = { class: "desc  pb-4" }
const _hoisted_6 = { class: "font-bold mb-2 lg:text-xl md:text-xl text-base" }
const _hoisted_7 = { class: "color-blue-grey mb-5 lg:text-base md:text-base text-sm sm-truncate-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputIconRightGrey = _resolveComponent("InputIconRightGrey")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Dropdown, {
        id: "id",
        modelValue: _ctx.typeMenu,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.typeMenu = $event)),
        options: [{name: 'Semua', id: 'all'},{name: 'Excel', id: 'excel'}, {name: 'Report', id: 'report'}],
        class: "dropdown-grey flex-shrink-0 text-sm w-1/3 sm:w-auto",
        optionLabel: "name",
        optionValue: "id",
        placeholder: "Pilih Tipe "
      }, null, 8, ["modelValue"]),
      _createVNode(_component_InputIconRightGrey, {
        placeholder: "Cari Disini ...",
        type: _ctx.$enumBase.input.text,
        modelValue: _ctx.inputSearch,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.inputSearch = $event)),
        onKeypress: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.changeSearch(_ctx.inputSearch)), ["enter"])),
        canClick: false,
        onSubmitInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeSearch(_ctx.inputSearch))),
        icon: _ctx.$icon.svg.searchEva
      }, null, 8, ["type", "modelValue", "icon"])
    ]),
    _createVNode("section", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataFilter, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          class: "flex w-full",
          key: 'report-' + index
        }, [
          _createVNode("div", _hoisted_3, [
            _createVNode("img", {
              src: _ctx.iconPath,
              class: "lg:w-18 md:w-16 w-10 mb-4"
            }, null, 8, ["src"]),
            _hoisted_4,
            _createVNode("div", _hoisted_5, [
              _createVNode("h6", {
                class: [item.Tipe.toLowerCase() == 'excel' ? 'color-green-darken-1' : '', "font-bold mb-1 lg:text-xl md:text-xl text-base"]
              }, _toDisplayString(`${item.Tipe}`), 3),
              _createVNode("h6", _hoisted_6, _toDisplayString(`${item.Judul}`), 1),
              _createVNode("p", _hoisted_7, "Memberikan ijin untuk report " + _toDisplayString(item.Keterangan), 1)
            ]),
            _createVNode("p", {
              class: "cursor-pointer color-primary hover-primary font-bold lg:text-base md:text-base text-sm absolute bottom-4 w-full",
              onClick: ($event: any) => (_ctx.showDetailReportSetting(item))
            }, " Berikan Ijin ", 8, ["onClick"])
          ])
        ]))
      }), 128))
    ])
  ]))
}